import { createGlobalStyle } from 'styled-components';

export const GlobalTypographyStyled = createGlobalStyle`
    html {
        height: 100%;
    }

    #root {
        height: 100%;
    }

    body {
        margin: 0;
        font-family: "OpenSans", sans-serif;
        font-size: var(--font-size-base);
        line-height: 1.5;
        font-weight: 300;
        background: var(--app-bg-color);
        color: var(--color-white);
    }

    h1, h2, h3, h4, h5, h6 {
        margin: 0;
        font-weight: 600;
        line-height: 1.3;
        color: var(--color-white-95);
    }

    h1 { font-size: var(--font-size-h1); }
    h2 { font-size: var(--font-size-h2); }
    h3 { font-size: var(--font-size-h3); }
    h4 { font-size: var(--font-size-h4); }
    h5 { font-size: var(--font-size-xl); }
    h6 { font-size: var(--font-size-base); }

    p {
        margin: 0;
    }

    .text-secondary {
        color: var(--text-color-secondary) !important;
    }

    .text-muted {
        color: var(--color-white-60) !important;
    }

    .section-eyebrow {
        font-size: var(--font-size-xs);
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: var(--color-accent);
    }

    @media (max-width: 576px) {
        body {
            font-size: var(--font-size-md);
        }
    }
`;
